import { useBlotterGroupingToggling } from '@talos/kyoko';
import type { UseBlotterTableUtilitiesOutput } from '@talos/kyoko/src/components/BlotterTable/types';
import type { StateUpdatedEvent } from 'ag-grid-community';
import { POSITIONS_PREDICTIONS_GROUPINGS } from './positionsPredictionsGroupings';

interface UsePositionsPredictionsBlotterGroupingParams {
  setRowGroupColumns: UseBlotterTableUtilitiesOutput<unknown>['setRowGroupColumns'];
}

interface UsePositionsPredictionsBlotterGroupingOutput {
  onGroupingStateUpdated: (event: StateUpdatedEvent) => void;
  groupingToggleButtons: ReturnType<typeof useBlotterGroupingToggling>['groupingToggleButtons'];
}

export function usePositionsPredictionsBlotterGrouping({
  setRowGroupColumns,
}: UsePositionsPredictionsBlotterGroupingParams): UsePositionsPredictionsBlotterGroupingOutput {
  const { onStateUpdated: onGroupingStateUpdated, groupingToggleButtons } = useBlotterGroupingToggling({
    blotterName: 'positions predictions',
    setRowGroupColumns,
    groupings: POSITIONS_PREDICTIONS_GROUPINGS,
    allowNoGrouping: true,
  });

  return { onGroupingStateUpdated, groupingToggleButtons };
}
